export default __webpack_public_path__ + "static/media/SQS-IATF-16949.fad068a4.jpg";